import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};

const BoxShadowIcon = ({
  id = 'box-shadow-icon',
  color = '#E6E6E6',
  size = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    {...props}
  >
    <defs>
      <linearGradient id={id} x1="100%" x2="0%" y1="50%" y2="50%">
        <stop offset="0%" stopColor={color} />
        <stop offset="100%" stopColor="#798588" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#798588"
        d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75"
      />
      <path
        fill={`url(#${id})`}
        d="M10 2.5a.625.625 0 0 0-.625.625v13.75c0 .345.28.625.625.625 4.136 0 7.5-3.364 7.5-7.5S14.136 2.5 10 2.5"
      />
    </g>
  </svg>
);

BoxShadowIcon.propTypes = propTypes;

export default BoxShadowIcon;
